import { useQuery } from '@tanstack/react-query';
import { NewsListResponse } from '@toggle/toggle';
import { WretchError } from 'wretch/types';

import { fetchNewsArticles } from '~/services/news/news-service';
import { NewsHighlights } from '~/views/news/hooks/use-fetch-infinite-news/useFetchInfiniteNewsList';
import {
  QUERY_KEY_MOST_READ_NEWS,
  QUERY_KEY_WATCHLIST_NEWS,
  REFETCH_INTERVAL_DASHBOARD,
  TabsType,
} from '~/views/news/utils/utils';

export const useNews = (activeTab: TabsType, entities: string[]) => {
  const sharedQueryFlags = {
    refetchInterval: REFETCH_INTERVAL_DASHBOARD,
    refetchIntervalInBackground: true,
  };
  const queries = {
    [TabsType.MostRead]: {
      queryKey: [QUERY_KEY_MOST_READ_NEWS, NewsHighlights.MostRead],
      queryFn: () =>
        fetchNewsArticles({
          highlights: [NewsHighlights.MostRead],
        }),
      ...sharedQueryFlags,
    },
    [TabsType.Watchlist]: {
      queryKey: [QUERY_KEY_WATCHLIST_NEWS, ...entities],
      queryFn: () => fetchNewsArticles({ entities }),
      ...sharedQueryFlags,
      enabled: !!entities.length,
    },
  };

  return useQuery<NewsListResponse, WretchError>({ ...queries[activeTab] });
};
